import React, { useEffect, useRef } from 'react';
import { StyledLoader } from './StyledLoader';
import { useSelector, useDispatch } from "react-redux";

import {
  setLoader,
} from "../../redux/loader/loader.actions";

const Loader = ({ arrayLoad, close, isFetching }) => {
  const loader = useSelector((state) => state.loader);
  const countLoaded = useRef(null);
  const dispatch = useDispatch();

  const loadImage = (src) => {
    
    return new Promise((resolve, reject) =>  {
      var img = new Image();
      img.onload = () => {
          resolve(img);

          // aggiungi immagine caricata
          countLoaded.current += 1;
          // se ha caricato tutte le immagini, trigger fine loading
          if(countLoaded.current === arrayLoad.length) {
            
            // timeout 2s per far finire la transizione d'entrata 
            // se ha già finito di caricare le img prima della fine della transizione
            setTimeout(() => {
              
              dispatch(setLoader(false))
              countLoaded.current = 0;
            }, 1000)
          }
      };
      img.onerror = img.onabort = () => {
        resolve(src);              
      };
      img.src = src;
    })
  }
  const preload = (array) => {
    
    var promises = [];
    for (var i = 0; i < array.length; i++) {
      promises.push(loadImage(array[i]));
    }
    
    return Promise.all(promises);
  }
  useEffect(() => {
    
    preload(arrayLoad);
  },[])

  useEffect(() => {

  },[close])

  return (
    <React.Fragment>
      {
       
          <StyledLoader className={`${!loader.isLoading ? 'loaded' : ''}`}>
            
              <div className="loading">
                <img src={require('../../assets/loader.gif')} />
                <p className="base">Entering Full Reality</p>
              </div>
              
            
          </StyledLoader>
          
      }
    </React.Fragment>
  );
};

Loader.propTypes = {};

Loader.defaultProps = {
  tag: "div",
  bgColor: "#fff",
  isFetching: false
};

export default Loader;
